<template>
  <v-container style="width: 50%;">
    <v-layout column>
      <v-flex class="screen-title">
        <span>Trial Account</span>
      </v-flex>
      <v-flex>
        <trial-account-invite-form
          :vs="$v"
          :initial-values="form"
          :reset.sync="reset"
          @values="form=$event"
        />
      </v-flex>
      <v-flex>
        <main-button
          depressed
          @click="submitForm"
        >
          Create trial account
        </main-button>
      </v-flex>

      <simple-snackbar v-bind.sync="snackbar" />
    </v-layout>
  </v-container>
</template>

<script>
import { required, email, minValue } from 'vuelidate/lib/validators'

import TrialAccountInviteForm from './trial-account-invite-form.vue'
import SimpleSnackbar from '../shared/snackbars/simple-snackbar.vue'
import { createTrialAccount } from '../../http'
import { submitGuard } from '../../utils'

export default {
  components: {
    TrialAccountInviteForm,
    SimpleSnackbar,
  },
  data() {
    return {
      snackbar: {
        open: false,
        messageProp: '',
        color: 'primary',
      },
      form: {
        firstName: '',
        lastName: '',
        email: '',
        eventQuota: 1,
      },
      reset: false,
    }
  },
  validations() {
    return {
      form: {
        firstName: { required },
        lastName: { required },
        email: { required, email },
        eventQuota: {
          required,
          minValue: minValue(1),
        },
      },
    }
  },
  methods: {
    async submitForm() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return null
      }
      await submitGuard(this, async () => {
        const { errors } = await createTrialAccount(this.form)
        if (errors) {
          const [e] = errors
          const { error, statusCode } = e

          return this.snackbar = {
            messageProp: statusCode ? statusCode === 400 && error.message : 'Something went wrong...',
            color: 'error',
            open: true,
          }
        }
        this.snackbar = {
          messageProp: 'An invitation email has been sent',
          color: 'primary',
          open: true,
        }
        this.reset = true
      })
    },
  },

}
</script>

<style>

</style>
